import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Footer from './Footer';
import './NotFound.css';

const NotFound = () => {
    // Effet pour envoyer le code d'état HTTP 404
    useEffect(() => {
        // Modification du titre de la page
        document.title = "404 - Page non trouvée | AstraLight";
        
        // Cette fonction essaie d'envoyer un véritable code d'état HTTP 404
        // Elle fonctionne si l'app est servie correctement via un serveur
        const setStatusCode = () => {
            try {
                // Pour React Router + serveurs supportant cette fonctionnalité
                if (typeof window !== 'undefined' && window.history?.replaceState) {
                    const url = window.location.pathname;
                    window.history.replaceState(
                        { status: 404 },
                        '404 - Page non trouvée',
                        url
                    );
                }
            } catch (err) {
                console.error('Erreur lors de la définition du code d\'état:', err);
            }
        };
        
        setStatusCode();
    }, []);

    return (
        <>
            <Helmet>
                <title>404 - Page non trouvée | AstraLight</title>
                <meta name="robots" content="noindex, follow" />
                <meta name="description" content="La page que vous recherchez n'existe pas ou a été déplacée." />
                <link rel="canonical" href="https://astralight.xyz/404" />
            </Helmet>

            <Navbar />

            <main className="not-found-page">
                <div className="container">
                    <div className="not-found-content panel">
                        <div className="stars-container">
                            <div className="stars star1"></div>
                            <div className="stars star2"></div>
                            <div className="stars star3"></div>
                        </div>
                        
                        <h1>404</h1>
                        <div className="celestial-divider"></div>
                        
                        <h2>Cette page s'est perdue dans l'univers</h2>
                        
                        <p className="not-found-message">
                            Comme une étoile filante, la page que vous recherchez est 
                            introuvable dans notre constellation de contenus.
                        </p>

                        <div className="lost-planet">
                            <div className="planet-orbit">
                                <div className="planet"></div>
                            </div>
                        </div>
                        
                        <div className="return-options">
                            <Link to="/" className="return-home-button">
                                Retour à l'accueil
                            </Link>
                            
                            <div className="suggestions">
                                <p>Vous pourriez être intéressé par :</p>
                                <ul>
                                    <li>
                                        <Link to="/calcul-theme-astral">Calculer votre thème astral</Link>
                                    </li>
                                    <li>
                                        <Link to="/compatibilite-amoureuse-astrologie">Vérifier votre compatibilité amoureuse</Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Explorer notre blog d'astrologie</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
};

export default NotFound; 